import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GlobalLoader, ProtectedRoute, PublicRoute } from '@/components';
import { USER_ROLES } from '@/constants/app';
import { DashboardLayout } from '@/components/layout';
import { LoginPage, NotFoundPage } from '@/pages';
// import { DashboardPage } from '@/pages/dashboard';

import { FacilitiesPage } from '@/pages/facilities';
import { FraternityPage } from '@/pages/fraternity';
import { BookingsPage } from '@/pages/bookings';
import { BookingLogsPage } from '@/pages/bookingLogs';



export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<GlobalLoader />}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        
        {/* Home - All authenticated users */}
        <Route
          path="/bookings"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Viewer, ]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<BookingsPage />} />
        </Route>

     
     

      
        {/* Facilities - Admin and Manager only */}
        <Route
          path="/facilities"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Viewer,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<FacilitiesPage />} />
        </Route>

        {/* Fraternity - Admin and Manager only */}
        <Route
          path="/fraternity"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Viewer,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<FraternityPage />} />
        </Route>

        {/* Bookings - Admin and Manager only */}
        <Route
          path="/bookings"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Viewer,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<BookingsPage />} />
        </Route>

        {/* Booking Logs - Admin and Manager only */}
        <Route
          path="/booking-logs"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Viewer,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<BookingLogsPage />} />
        </Route>

        {/* Profile - All authenticated users */}
        {/* <Route
          path="/profile"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.ADMIN, USER_ROLES.MANAGER,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ProfilePage />} />
        </Route> */}

        {/* Settings - Admin only */}
        {/* <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.Booking_Admin, USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<div>Settings - Admin Only</div>} />
        </Route> */}

     

        {/* <Route
          path="/configuration/subject-configuration"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<SubjectConfiguration />} />
        </Route> */}

        {/* Default redirect */}
        <Route
          path="/"
          element={<Navigate to="/bookings" replace />}
        />
        
        {/* 404 Page */}
        <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Routes>
    </Suspense>
  );
};